import PropTypes from 'prop-types'
import React from 'react'

import { TextSmall } from 'styles/components/typography'
import { grass, black } from 'styles/theme/colors'

import {
  Li,
  Inner,
  Bullet,
  TitleWrapper,
  Description,
  IconStyled,
  TextUpperStyled,
  TextWrapper,
} from './styles'

const ARROW_POS = {
  left: 'left',
  right: 'right',
}

/**
 * Component of ClickableDescr. It is active component to show title with description.
 * It has passive and active render types. Passive with classic List bullet and
 * Active with long arrow.
 *
 * @return {function} Function — ListItem
 */
const ClickableDescr = ({
  data,
  isActive,
  bulletColor,
  noHover,
  onClick,
  arrowPosition,
  arrowColor,
}) => {
  let propsOnClick = { onClick }

  if (noHover) {
    propsOnClick = {}
  }

  return (
    <Li {...{ isActive, noHover }} {...propsOnClick}>
      <Inner>
        <TitleWrapper>
          <Bullet {...{ bulletColor }}>•</Bullet>
          <TextWrapper>
            <TextUpperStyled dangerouslySetInnerHTML={{ __html: data.title }} />
            &shy;
            {!noHover && (
              <IconStyled
                {...{ arrowPosition }}
                strokeWidth="2"
                id={`arrow_long_${arrowPosition}`}
                color={arrowColor}
              />
            )}
          </TextWrapper>
        </TitleWrapper>
        <Description>
          <TextSmall dangerouslySetInnerHTML={{ __html: data.description }} />
        </Description>
      </Inner>
    </Li>
  )
}

ClickableDescr.propTypes = {
  /** Object with data */
  data: PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,

  /** On description click call back (does not called when noHover === true) */
  onClick: PropTypes.func.isRequired,

  /** Arrow position relative to title */
  arrowPosition: PropTypes.oneOf(Object.keys(ARROW_POS)),

  /** Arrow color */
  arrowColor: PropTypes.string,

  /** Bullet color code */
  bulletColor: PropTypes.string,

  /** Flag to control state of description */
  isActive: PropTypes.bool,

  /** Flag to control possibility of description */
  noHover: PropTypes.bool,
}
ClickableDescr.defaultProps = {
  arrowPosition: ARROW_POS.left,
  arrowColor: black,
  bulletColor: grass,
  isActive: false,
  noHover: false,
}

export default ClickableDescr
